import { render } from "./VerifyOwnershipCertificate.vue?vue&type=template&id=986b60a2&scoped=true"
import script from "./VerifyOwnershipCertificate.vue?vue&type=script&lang=js"
export * from "./VerifyOwnershipCertificate.vue?vue&type=script&lang=js"

import "./VerifyOwnershipCertificate.vue?vue&type=style&index=0&id=986b60a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986b60a2"]])

export default __exports__